<template>
  <v-container class="ma-0 pa-0">
    <div v-for="(item, i) in view_items" :key="i">
      <div class="text-left">
        <h2 v-if="i === 0" class="pt-8 secondary--text">{{ item["title"] }}</h2>
        <h2 v-else class="pt-12 secondary--text">{{ item["title"] }}</h2>
      </div>
      <div class="three60-container">
        <iframe
          :src="item['url']" class="three60-view"
          frameborder="0" allowfullscreen="">
        </iframe>
      </div>
    </div>
  </v-container>
</template>

<style scoped>
  .three60-container {
    height: 80vh;
  }
  .three60-view {
    width: 100%;
    height: 100%;
    border: 0;
  }
</style>

<script>
export default {
  name: 'Map',

  data: () => ({
    view_items: [
      {
        title: "THE ROOM",
        url: "https://www.google.com/maps/embed?pb=!4v1580005940723!6m8!1m7!1sCAoSK0FGMVFpcE1sa2Z3MldsSTdfdnpidjI2d2pmbndab294WTVWSjRwQkVoMFU.!2m2!1d12.8181304!2d80.0407056!3f9.849790046009074!4f-6.311113826371795!5f0.4000000000000002",
      },
      {
        title: "THE BATHROOM",
        url: "https://www.google.com/maps/embed?pb=!4v1580003574079!6m8!1m7!1sCAoSK0FGMVFpcE5SVGxIYVNyYTFLZ1ZHUS0xYUpabW5NMGpyV2hsc3VvWE1FVm8.!2m2!1d12.8181739!2d80.04073319999999!3f58.21435928858811!4f-12.248349668345725!5f0.4000000000000002",
      },
    ],
  }),
};
</script>
